<template>
  <div class="display_between head EC_width">
    <ul class="menu">
      <li v-for="(item, index) in nvgList" :key="index" class="menuitem" @click="meetingDetail(item)">{{ item.columnName
      }}</li>
    </ul>
    <div v-show="displayTime">
      <div class="signMenu" v-if="!flag">距离会议开始还有{{ time }}天</div>
      <div class="signMenu" v-if="flag">已结束</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'meeting_head',
  data() {
    return {
      // 当为true时时间到了
      flag: false,
      time: '',
      nvgList: [],
      webSiteColumnlist: [],
      mtgId: 2,
      displayTime: false,
      AuthorId: '',
      qid: 0
    };
  },
  created() {
    if (this.$route.query.mid != '') {
      this.mtgId = this.$route.query.mid;
    }
    if (!this.isMobile()) {
      this.GetWebSiteConfigList();
    }
  },
  methods: {
    timeDown(date) {
      const endTime = new Date(date);
      const nowTime = new Date();
      let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
      let d = parseInt(leftTime / (24 * 60 * 60));
      if (d < 0) {
        this.flag = true;
      }
      this.time = `${d + 1}`;
    },
    GetWebSiteConfigList() {
      let _this = this;
      this.httphelper
        .post('/api/WebSiteConfigApi/GetWebSiteConfigList', {
          mtg_Id: parseInt(_this.mtgId),
          type: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            var data = res.data.data.webSiteNaviglist;
            data.forEach(item => {
              if (item.parentID == 0) {
                _this.nvgList.push(item);
              }
            });
            // _this.nvgList = res.data.data.webSiteNaviglist
            //网站栏目信息列表
            _this.webSiteColumnlist = res.data.data.webSiteColumnlist;
            _this.webSiteColumnlist.forEach(item => {
              if (item.fromItemID == 1) {
                //倒计时
                _this.displayTime = true;
                _this.timeDown(item.countdown.replace(/\-/g, "/"));
              }
            });
          }
        });
    },
    // 判断是手机还是pc
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    //跳转页面
    meetingDetail(item) {
      let _target = '_self';
      //是否在新页面打开
      if (item.isOpenNewpage) {
        _target = '_blank';
      }
      if (item.columnType == '系统类' && item.columnName == '首页') {
        this.$router.push({ name: 'meetingpc', query: { mid: this.mtgId } });
      }
      // else if (item.columnType == "参会注册") {
      // } else if (item.columnType == "个人中心") {
      // }
      else if (item.columnType == '图文类') {
        const { href } = this.$router.resolve({
          path: 'meetingDetail',
          query: { id: item.id, mid: this.mtgId, type: 1 }
        });
        window.open(href, _target);
      } else if (item.columnType == '跳转连接') {
        if (item.hyperlinks.indexOf('muduLive') > -1 || item.hyperlinks.indexOf('huodeLive') > -1) {
          if (this.$cookies.isKey('token_chinagp')) {
            var _tokenkey = this.$cookies.get('token_chinagp');
            this.httphelper
              .post('/api/LoginApi/CheckToken', {
                tokenKey: _tokenkey
              })
              .then(res => {
                if (res.data.code == 200) {
                  // item.hyperlinks = item.hyperlinks + '&mid=' + this.mtgId
                  // window.open(item.hyperlinks, _target)
                  this.AuthorId = res.data.data.id;
                  item.hyperlinks = item.hyperlinks + '&mid=' + this.mtgId + '&tokenkey=' + _tokenkey;
                  this.toLive(this.getParamQueryString(item.hyperlinks, 'id'), item.hyperlinks.indexOf('muduLive') > 0 ? 1 : 2, item.hyperlinks, _target);
                } else {
                  this.$alert('请先登录', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      let callback = encodeURIComponent(window.location.href);
                      window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                    }
                  });
                }
              });
          } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
            this.httphelper
              .post('/api/LoginApi/CheckToken', {
                tokenKey: this.$route.query.tokenkey
              })
              .then(res => {
                if (res.data.code == 200) {
                  // item.hyperlinks = item.hyperlinks + '&mid=' + this.mtgId
                  // window.open(item.hyperlinks, _target)
                  this.AuthorId = res.data.data.id;
                  item.hyperlinks = item.hyperlinks + '&mid=' + this.mtgId + '&tokenkey=' + _tokenkey;
                  this.toLive(this.getParamQueryString(item.hyperlinks, 'id'), item.hyperlinks.indexOf('muduLive') > 0 ? 1 : 2, item.hyperlinks, _target);
                } else {
                  this.$alert('请先登录', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      let callback = encodeURIComponent(window.location.href);
                      window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
                    }
                  });
                }
              });
          } else {
            this.$alert('请先登录', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                let callback = encodeURIComponent(window.location.href);
                window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
              }
            });
          }
        } else {
          window.open(item.hyperlinks, _target);
        }
      }
    },
    getParamQueryString(url, name) {
      let subStr = name + '=';
      if (url.indexOf(subStr) !== -1) {
        let arr = url.split(subStr);
        let sub1 = arr[1];
        if (sub1.indexOf('&') !== -1) {
          let arr2 = sub1.split('&');
          let sub2 = arr2[0];
          return sub2;
        } else {
          return sub1;
        }
      }
      return '';
    },
    toLive(id, liveType, url, target) {
      //验证是否需要报名
      this.httphelper
        .post('/api/LiveApi/GetLiveRegistSet', {
          LiveId: id.toString(),
          LiveType: parseInt(liveType),
          MtgId: parseInt(this.mtgId),
          UserId: parseInt(this.AuthorId)
        })
        .then(res => {
          if (res.data.code != 200) {
            this.$alert('请先报名会议在观看', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.regcheck();
              }
            });
          } else {
            // if (this.mtgId > 0) {
            this.CheckIsQuestionnaire(id, liveType, url, target);
            // } else {
            //   //已经报名了，跳转直播页面
            //   window.open(url, target);
            // }
          }
        });
    },
    //验证是否需要问卷
    CheckIsQuestionnaire(id, liveType, url, target) {
      this.httphelper.get('/api/LiveApi/CheckIsQuestionnaire?mid=' + this.mtgId + '&liveid=' + id + '&livetype=' + parseInt(liveType)).then(res => {
        if (res.code == 200) {
          window.open(url, target);
        } else {
          if (res.code == 20) {
            this.qid = res.data.id;
            //验证当前用户是否报名
            this.httphelper.get('/api/QuestionnaireApi/CheckIsFeedback?qid=' + res.data.id + '&userid=' + this.AuthorId).then(res => {
              if (res.code == 200) {
                //继续观看
                window.open(url, target);
              } else {
                //跳转调查问卷
                this.$alert('请先填写调查问题', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    let callback = encodeURIComponent(window.location.href);
                    this.$router.push({
                      path: '/question?',
                      query: {
                        qid: this.qid,
                        callback: callback
                      }
                    });
                  }
                });
              }
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        }
      });
    },
    //判断是否报名，否跳转会议报名
    regcheck() {
      if (this.$cookies.isKey('token_chinagp')) {
        var _tokenkey = this.$cookies.get('token_chinagp');
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: _tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
            } else {
              let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
              window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
            }
          });
      } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: this.$route.query.tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
            } else {
              let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
              window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
            }
          });
      } else {
        var hrefurl = '';
        hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
        let callback = encodeURIComponent(hrefurl);
        window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
      }
    }
  }
};
</script>

<style scoped>
.head {
  padding: 20px 0;
}

.menu {
  list-style: none;
  margin: 0;
  padding: 0;
  display: inline-block;
}

.menuitem {
  display: inline-block;
  color: rgb(98, 104, 196);
  font-weight: bold;
  font-size: 14px;
  padding: 0 30px;
  cursor: pointer;
}

.signMenu {
  display: inline-block;
  background-color: rgb(98, 104, 196);
  color: #fff;
  padding: 0px 12px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  height: 40px;
  line-height: 40px;
}
</style>
